<script setup lang="ts">

const shades = [ 950, 900, 850, 800, 750, 700, 650, 600, 550, 500, 400, 300, 200, 150, 100, 50 ];

</script>

<template>

    <div>
    
        <h1 class="px-3 pb-2 flex items-center justify-between">
            <div>Palette</div>
        </h1>

        <div class="grid grid-cols-8 text-sm font-bold">
            <div v-for="shade in shades"
                 class="aspect-square flex items-center justify-center" 
                 :class="[ 'bg-gray-' + shade, { 'text-gray-900': shade < 500 } ]">
                {{ shade }}
            </div>
        </div>

    </div>

</template>